export default {
    CABD_API: 'https://cabd-web.azurewebsites.net/cabd-api/',
};
